/** Per-category accent of a result: `fg` for numbers, bars and watermark, `bg` for the hero ground. */
export interface ResultAccent {
  key: ResultCategoryKey;
  fg: string;
  bg: string;
}

export type ResultCategoryKey = 'ielts' | 'sat' | 'dtm' | 'attestatsiya' | 'milliy' | 'umumiy' | 'tillar';

export const RESULT_ACCENTS: Record<ResultCategoryKey, ResultAccent> = {
  ielts: { key: 'ielts', fg: '#B42318', bg: '#FDECEC' },
  sat: { key: 'sat', fg: '#1D4ED8', bg: '#E8EEFF' },
  dtm: { key: 'dtm', fg: '#C2410C', bg: '#FFEFE5' },
  attestatsiya: { key: 'attestatsiya', fg: '#166534', bg: '#E6F4EC' },
  milliy: { key: 'milliy', fg: '#0B4F5C', bg: '#E3F2F4' },
  umumiy: { key: 'umumiy', fg: '#6D28D9', bg: '#F3ECFF' },
  tillar: { key: 'tillar', fg: '#92400E', bg: '#FFF4D6' },
};

/** Maps a test's `category` string (several spellings exist in data) onto a result category. */
export function resultCategoryKey(category?: string | null, standard?: 'IELTS' | 'SAT' | null): ResultCategoryKey {
  if (standard === 'IELTS') return 'ielts';
  if (standard === 'SAT') return 'sat';
  const c = (category ?? '').trim().toLowerCase();
  if (c === 'ielts') return 'ielts';
  if (c === 'sat') return 'sat';
  if (c === 'dtm') return 'dtm';
  if (c.startsWith('milliy')) return 'milliy';
  if (c === 'attestation' || c === 'attestatsiya') return 'attestatsiya';
  if (['languages', 'til', 'tillar'].includes(c)) return 'tillar';
  return 'umumiy';
}

/** Bar colour by share correct: green, amber, red. */
export function toneForPercent(percent: number, good = 75, ok = 55): string {
  if (percent >= good) return '#166534';
  if (percent >= ok) return '#E9A23B';
  return '#B42318';
}
